import type { OsRecipe } from '../os-recipes.js';
import { LAUNCHABLE_APPS } from '../os-verbs.js';

/** R4b: the words that admit the Mac's own acts (recipe-questions.ts admittedApps), which have no app
 *  to name: each one a cue of a recipe below (os-recipes-data.test.ts), so an admission always has
 *  something to offer. Never "mute" ("mute me" is their own mic on a call, never the speakers), nor
 *  "loud" ("read it out loud" asks for no system act, and would spend one of the two app slots). */
export const SYSTEM_TOPIC_WORDS: readonly string[] = ['volume', 'sound', 'awaaz', 'hide'];

/** system: the Mac's own acts as data (Mac recipes R3), app-less and verbs only. Every entry ships held
 *  until its drill lifts it. Most system acts are reflex verbs, not recipes: a recipe stands only where
 *  its verb's param is open (a number, a name), so the reflex could not offer the verb itself. The
 *  research rows not here are on the R3 review lists. */
export const RECIPES: readonly OsRecipe[] = [
  // system.volume_set takes a number, so the reflex offers it only through this closed list of levels.
  {
    id: 'system.volume_set', app: null, system: true, status: 'held',
    title: 'Set the Mac volume',
    description: 'Set the Mac volume ("volume to 40").',
    params: { level: { kind: 'enum', description: "0-100 from code's number parser (half = 50, full = 100)", enum: ['0', '10', '20', '25', '30', '40', '50', '60', '70', '75', '80', '90', '100'] } },
    steps: [{ op: 'verb', id: 'system.volume_set', params: { level: '{level}' } }],
    tier: 'reversible', cues: ['volume', 'sound', 'awaaz', 'loud'],
    reply: 'Volume is {level}.',
  },
  // sysevents.app_hide takes a name, so the reflex offers it only through this recipe (research id system.hide_others).
  // R4b: the name is one of the launchable apps, by its System Events process name ("zoom.us" for Zoom),
  // the one their words name by any of its names (code checks it is said, recipe-words.ts): "hide the
  // sidebar" hides no app called "sidebar".
  {
    id: 'system.hide_app', app: null, system: true, status: 'held',
    title: 'Hide an app',
    description: 'Hide an app ("hide slack").',
    params: {
      name: {
        kind: 'enum', description: 'The app to hide (its process name)', apps: true,
        enum: LAUNCHABLE_APPS.map((a) => a.process ?? a.name), labels: Object.fromEntries(LAUNCHABLE_APPS.map((a) => [a.process ?? a.name, a.name])),
      },
    },
    steps: [{ op: 'verb', id: 'sysevents.app_hide', params: { name: '{name}', hidden: true } }],
    tier: 'reversible', cues: ['hide'],
    reply: 'Hid {name}.',
  },
];
